import type {PrintoutDateFormat} from "../../../variables/printoutVariables";

export const DATE_FORMAT_OPTIONS: readonly {label: string; value: PrintoutDateFormat}[] = [
    {label: "Numeric · 01.09.2026", value: "numeric"},
    {label: "Short · 1 Sept 2026", value: "short"},
    {label: "Long · 1 September 2026", value: "long"},
    {label: "With weekday · Tuesday, 1 September 2026", value: "weekday"},
];
